import Api from '@/api/Api'
import store from '../store'

export default {

  async getLatest () {
    return store.dispatch('checkResponseApi', await Api().get('version/latest'))
  },

}



// WEBPACK FOOTER //
// ./src/api/VersionService.js